import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AuthService } from '@core/services/auth.service';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { Validators } from 'ngx-editor';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs';
import { matchPassword } from '@core/validators/match-password.validator';
import { patternInvalidator, patternValidator } from '@core/validators/pattern.validator';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProfileComponent implements OnInit {
  faEye = faEye;
  faEyeSlash = faEyeSlash;
  currentUser!: any;
  showPassword = false;
  showConfirmPassword = false;
  changePasswordForm: FormGroup | any;

  constructor(private authService: AuthService, private fb: FormBuilder, private toastr: ToastrService) {}

  get newPassword() { return this.changePasswordForm.get('newPassword'); }
  get confirmPassword() { return this.changePasswordForm.get('confirmPassword'); }

  ngOnInit(): void {
      this.currentUser = this.authService.getCurrentUser();
      this.initForm();
  }

  initForm(): void {
    this.changePasswordForm = this.fb.group({
      newPassword: [null, [
        Validators.required,
        Validators.minLength(8),
        patternValidator(/\d/, { 'Missing Number': false }),
        patternValidator(/[A-Z]/, { 'Missing Uppercase character': false }),
        patternValidator(/[a-z]/, { 'Missing Lowercase character': false }),
        patternValidator(/[!@#\[\]\$%\^\*`~\-\=()_,.:><\\\/?]/, {
          'Missing Special Character': false,
        }),
        patternInvalidator(/[\+\&]/, {
          'Invalid Special Characters Used: &/+': false,
        }),
      ],],
      confirmPassword: ['', [Validators.required,  Validators.minLength(8)]],
    }, { validator: matchPassword('newPassword', 'confirmPassword') });
  }

  submit(): void {
    if (this.changePasswordForm.invalid) {
      this.toastr.error('Please fix your form errors!');
       return;
    }

    this.authService.changePassword(this.changePasswordForm.value.newPassword, 'Password successfully changed!')
    .pipe(take(1))
    .subscribe(res=> { this.changePasswordForm.reset(); });

  }

  togglePassword(type: string): void {
    if(type == 'password') this.showPassword = !this.showPassword;
    else this.showConfirmPassword = !this.showConfirmPassword;
  }
}
